/**
 * @generated SignedSource<<7e76a22acefd77e6c18868b9f8488afc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpTPayload",
        "kind": "LinkedField",
        "name": "createCpT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCpTPayload",
        "kind": "LinkedField",
        "name": "createCpT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "456d917138ec2095d037ca5c5f71df72",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramCreateMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramCreateMutation(\n  $input: CreateCpTInput!\n) {\n  createCpT(input: $input) {\n    cpT {\n      cpId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "697eea16b1f8cb061070923b8e1fc299";

module.exports = node;
